<template>
    <modal :open="showModal" @close="closeModal">
        <template v-if="showModal">
            <div class="modal-header">
                <button @click="closeModal()" type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="text-center">
                    <span class="text-primary icon icon-question-circle icon-5x"></span>
                    <h3 class="text-primary">{{ $t('globals.confirm_action') }}</h3>
                    <p v-html="$t('users.accept_join_request_question', {
                        emphasizedOpen: '<span class=&quot;font-semibold&quot;>',
                        name: fullName,
                        emphasizedClose: '</span>',
                    })"></p>
                    <div class="m-t-lg">
                        <button @click="closeModal()" class="btn btn-default mr-2" type="button">{{ $t('globals.cancel') }}</button>
                        <button @click="acceptJoinRequest()" class="btn btn-primary" type="button">{{ $t('users.accept_request') }}</button>
                    </div>
                </div>
            </div>
            <div class="modal-footer"></div>
        </template>
    </modal>
</template>

<script>
import Modal from '../../../user/partials/modal.vue';

export default {
    components: {
        'modal': Modal,
    },

    data() {
        return {
            showModal: false,
            joinRequest: null,
            form: new Form({
                join_request_id: '',
            }),
        };
    },

    created() {
        Bus.$on('showAcceptJoinRequestModal', ({ joinRequest }) => this.openModal(joinRequest));
    },

    computed: {
        fullName() {
            if (!this.joinRequest) {
                return;
            }
            return `${this.joinRequest.user.first_name} ${this.joinRequest.user.last_name}`;
        },
    },

    methods: {
        openModal(joinRequest) {
            this.joinRequest = joinRequest;
            this.showModal = true;
        },

        closeModal() {
            this.showModal = false;
            this.joinRequest = null;
            this.resetForm();
        },

        resetForm() {
            this.form = new Form({
                join_request_id: '',
            });
        },

        acceptJoinRequest() {
            this.form.join_request_id = this.joinRequest.id;

            Globals.post('/api/v1/accept-join-request', this.form)
                .then(() => {
                    const flash = { type: 'success', message: this.$t('users.join_request_accepted') };
                    window.sessionStorage.setItem('flash', JSON.stringify(flash));
                    window.location.reload();
                })
                .catch(() => {
                    const message = this.form.errors.has('join_request_id')
                        ? this.form.errors.get('join_request_id')
                        : this.$t('globals.unexpected_error');
                    this.closeModal();
                    window.toastr.clear();
                    window.toastr.error(message);
                });
        },
    },
};
</script>
